module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_weddingshower-196069bbcf8df7e26230116d2286c449.jpg";